import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- FAQ ---------------------------------------*
  // *===============================================---*
  {
    path: '/faq/list',
    name: 'pages-FAQs-list',
    component: () => import('@/views/pages/faq/FAQList.vue'),
    meta: {
      resource: 'faq',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('FAQs.mainVerticalMenu.FAQs'),
    },
  },
  {
    path: '/faq/add',
    name: 'pages-FAQs-add',
    component: () => import('@/views/pages/faq/FAQAdd.vue'),
    meta: {
      resource: 'faq',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('FAQs.mainVerticalMenu.FAQs'),
    },
  },
  {
    path: '/faq/edit/:id',
    name: 'pages-FAQs-edit',
    component: () => import('@/views/pages/faq/FAQEdit.vue'),
    meta: {
      resource: 'faq',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('FAQs.mainVerticalMenu.FAQs'),
    },
  },
  {
    path: '/faqCategory/list',
    name: 'pages-FAQs-categories-list',
    component: () => import('@/views/pages/faqCategory/FAQCategoryList.vue'),
    meta: {
      resource: 'faqCategory',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('FAQs.mainVerticalMenu.FAQCategory'),
    },
  },
  {
    path: '/faqCategory/add',
    name: 'pages-FAQs-categories-add',
    component: () => import('@/views/pages/faqCategory/FAQCategoryAdd.vue'),
    meta: {
      resource: 'faqCategory',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('FAQs.mainVerticalMenu.FAQCategory'),
    },
  },
  {
    path: '/faqCategory/edit/:id',
    name: 'pages-FAQs-categories-edit',
    component: () => import('@/views/pages/faqCategory/FAQCategoryEdit.vue'),
    meta: {
      resource: 'faqCategory',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('FAQs.mainVerticalMenu.FAQCategory'),
    },
  },
]
